// import React, { useState, useEffect } from "react";
// import { Loader, CheckCircle } from "lucide-react";
// import { adminUserService } from "../../../services/api/admin.user.service";
// import { notificationService } from "../../../services/api/notification.service";

// const getAuthHeader = () => ({
//   Authorization: `Bearer ${
//     localStorage.getItem("authToken") || "your-token-here"
//   }`,
// });

// // Add this API service function (you can also add it to your existing service file)


// const WalletManagement = () => {
//   // State management
//   const [wallets, setWallets] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [markingAsRead, setMarkingAsRead] = useState(false);
//   const [pagination, setPagination] = useState({
//     total: 0,
//     page: 1,
//     limit: 10,
//     pages: 0,
//   });

//   // Filter states
//   const [filters, setFilters] = useState({
//     status: "",
//     currency: "",
//     minBalance: "",
//     maxBalance: "",
//     userId: "",
//     search: "",
//     sortBy: "createdAt",
//     sortOrder: "desc",
//   });

//   // Helper function to check if wallet is new (created within last 24 hours)
//   const isNewWallet = (createdAt) => {
//     if (!createdAt) return false;
//     const walletDate = new Date(createdAt);
//     const now = new Date();
//     const timeDifference = now - walletDate;
//     const hoursDifference = timeDifference / (1000 * 60 * 60);
//     return hoursDifference <= 24;
//   };

//   // Check if there are any new wallets
//   const hasNewWallets = wallets.some(wallet => isNewWallet(wallet.createdAt));

//   // Fetch wallets with current filters and pagination
//   const fetchWallets = async () => {
//     try {
//       setLoading(true);

//       // Build query parameters
//       const params = {
//         page: pagination.page,
//         limit: pagination.limit,
//       };

//       Object.keys(filters).forEach((key) => {
//         if (
//           filters[key] !== "" &&
//           filters[key] !== null &&
//           filters[key] !== undefined
//         ) {
//           params[key] = filters[key];
//         }
//       });

//       // Call API from service
//       const response = await adminUserService.getWallets(params);

//       if (response.success) {
//         setWallets(response.data.wallets);
//         setPagination(response.data.pagination);
//       } else {
//         setError("Failed to fetch wallets");
//       }
//     } catch (err) {
//       setError(err.message || "Error fetching wallet data");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Handle marking wallet notifications as read
//   const handleMarkAsRead = async () => {
//     try {
//       setMarkingAsRead(true);
//       await notificationService.markCategoryAsRead('Wallet');
      
//       // Optionally refresh the wallet data to update the UI
//       await fetchWallets();
      
//       // You might want to show a success message

//     } catch (error) {
//       console.error('Error marking notifications as read:', error);
//       setError('Failed to mark notifications as read');
//     } finally {
//       setMarkingAsRead(false);
//     }
//   };

//   // Initial load and when filters/pagination change
//   useEffect(() => {
//     fetchWallets();
//   }, [pagination.page, pagination.limit, filters.sortBy, filters.sortOrder]);

//   // Handle filter changes
//   const handleFilterChange = (e) => {
//     const { name, value } = e.target;
//     setFilters((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   // Apply filters
//   const applyFilters = (e) => {
//     e.preventDefault();
//     setPagination((prev) => ({
//       ...prev,
//       page: 1,
//     }));
//     fetchWallets();
//   };

//   // Reset filters
//   const resetFilters = () => {
//     setFilters({
//       status: "",
//       currency: "",
//       minBalance: "",
//       maxBalance: "",
//       userId: "",
//       search: "",
//       sortBy: "createdAt",
//       sortOrder: "desc",
//     });

//     setPagination((prev) => ({
//       ...prev,
//       page: 1,
//     }));
//   };

//   // Handle sort change
//   const handleSort = (field) => {
//     setFilters((prev) => ({
//       ...prev,
//       sortBy: field,
//       sortOrder:
//         prev.sortBy === field && prev.sortOrder === "desc" ? "asc" : "desc",
//     }));
//   };

//   // Handle page change
//   const handlePageChange = (newPage) => {
//     if (newPage > 0 && newPage <= pagination.pages) {
//       setPagination((prev) => ({
//         ...prev,
//         page: newPage,
//       }));
//     }
//   };

//   // Format date to readable format
//   const formatDate = (dateString) => {
//     return new Date(dateString).toLocaleString();
//   };

//   return (
//     <div className="container mx-auto px-4 py-8">
//       <div className="flex justify-between items-center mb-6">
//         <h1 className="text-2xl font-bold">Wallet Management</h1>
        
//         {/* Mark as Read Button - Only show if there are new wallets */}
//         {hasNewWallets && (
//           <button
//             onClick={handleMarkAsRead}
//             disabled={markingAsRead}
//             className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 disabled:bg-blue-400 text-white font-medium py-2 px-4 rounded-md transition-colors"
//           >
//             {markingAsRead ? (
//               <Loader className="animate-spin" size={16} />
//             ) : (
//               <CheckCircle size={16} />
//             )}
//             {markingAsRead ? 'Marking as Read...' : 'Mark New Wallets as Read'}
//           </button>
//         )}
//       </div>

//       {/* Show notification banner if there are new wallets */}
//       {hasNewWallets && (
//         <div className="mb-4 bg-blue-50 border border-blue-200 rounded-md p-4">
//           <div className="flex items-center justify-between">
//             <div className="flex items-center gap-2">
//               <div className="w-3 h-3 bg-blue-500 rounded-full animate-pulse"></div>
//               <span className="text-blue-800 font-medium">
//                 {wallets.filter(w => isNewWallet(w.createdAt)).length} new wallet(s) created in the last 24 hours
//               </span>
//             </div>
//             <button
//               onClick={handleMarkAsRead}
//               disabled={markingAsRead}
//               className="text-blue-600 hover:text-blue-800 text-sm font-medium"
//             >
//               Mark as Read
//             </button>
//           </div>
//         </div>
//       )}

//       {/* Results Table */}
//       <div className="overflow-hidden">
//         {loading ? (
//           <div className="flex justify-center items-center h-screen">
//             <Loader className="animate-spin text-indigo-500" size={36} />
//           </div>
//         ) : error ? (
//           <div className="text-center py-8 text-red-500">
//             <p>{error}</p>
//             <button
//               onClick={fetchWallets}
//               className="mt-4 bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-md transition-colors"
//             >
//               Try Again
//             </button>
//           </div>
//         ) : wallets.length === 0 ? (
//           <div className="text-center py-8 text-gray-500">
//             <p>No wallets found matching your criteria.</p>
//           </div>
//         ) : (
//           <div className="overflow-x-auto">
//             <table className="w-full table-auto">
//               <thead className="bg-gray-50">
//                 <tr>
//                   <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                     User Details
//                   </th>
//                   <th
//                     className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer"
//                     onClick={() => handleSort("currency")}
//                   >
//                     Currency
//                     {filters.sortBy === "currency" && (
//                       <span className="ml-1">
//                         {filters.sortOrder === "asc" ? "↑" : "↓"}
//                       </span>
//                     )}
//                   </th>
//                   <th
//                     className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer"
//                     onClick={() => handleSort("balance")}
//                   >
//                     Balance
//                     {filters.sortBy === "balance" && (
//                       <span className="ml-1">
//                         {filters.sortOrder === "asc" ? "↑" : "↓"}
//                       </span>
//                     )}
//                   </th>
//                   <th
//                     className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer"
//                     onClick={() => handleSort("status")}
//                   >
//                     Status
//                     {filters.sortBy === "status" && (
//                       <span className="ml-1">
//                         {filters.sortOrder === "asc" ? "↑" : "↓"}
//                       </span>
//                     )}
//                   </th>
//                   <th
//                     className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer"
//                     onClick={() => handleSort("createdAt")}
//                   >
//                     Created At
//                     {filters.sortBy === "createdAt" && (
//                       <span className="ml-1">
//                         {filters.sortOrder === "asc" ? "↑" : "↓"}
//                       </span>
//                     )}
//                   </th>
//                 </tr>
//               </thead>
//               <tbody className="bg-white divide-y divide-gray-200">
//                 {wallets.map((wallet) => (
//                   <tr key={wallet._id} className="hover:bg-gray-50">
//                     <td className="px-6 py-4 whitespace-nowrap">
//                       <div className="flex items-center gap-3">
//                         <div className="flex flex-col">
//                           <div className="text-sm font-medium text-gray-900 flex items-center gap-2">
//                             {wallet.userDetails.fullName}
//                             {isNewWallet(wallet.createdAt) && (
//                               <span className="w-2 h-2 bg-blue-500 rounded-full flex-shrink-0"></span>
//                             )}
//                           </div>
//                           <div className="text-sm text-gray-500">
//                             {wallet.userDetails.email}
//                           </div>
//                           <div className="text-xs text-gray-500">
//                             {wallet.userDetails.mobileNo}
//                           </div>
//                           <div className="text-xs text-gray-400">
//                             ID: {wallet.user.toString()}
//                           </div>
//                         </div>
//                       </div>
//                     </td>
//                     <td className="px-6 py-4 whitespace-nowrap">
//                       <div className="flex items-center gap-2">
//                         <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
//                           {wallet.currency}
//                         </span>
//                         {isNewWallet(wallet.createdAt) && (
//                           <span className="w-2 h-2 bg-blue-500 rounded-full flex-shrink-0"></span>
//                         )}
//                       </div>
//                     </td>
//                     <td className="px-6 py-4 whitespace-nowrap">
//                       <div className="flex items-center gap-2">
//                         <div className="text-sm font-medium text-gray-900">
//                           {parseFloat(wallet.balance).toFixed(4)}
//                         </div>
//                         {isNewWallet(wallet.createdAt) && (
//                           <span className="w-2 h-2 bg-blue-500 rounded-full flex-shrink-0"></span>
//                         )}
//                       </div>
//                     </td>
//                     <td className="px-6 py-4 whitespace-nowrap">
//                       <div className="flex items-center gap-2">
//                         <span
//                           className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium
//                           ${
//                             wallet.status === "ACTIVE"
//                               ? "bg-green-100 text-green-800"
//                               : wallet.status === "INACTIVE"
//                               ? "bg-gray-100 text-gray-800"
//                               : wallet.status === "FROZEN"
//                               ? "bg-red-100 text-red-800"
//                               : "bg-yellow-100 text-yellow-800"
//                           }
//                         `}
//                         >
//                           {wallet.status}
//                         </span>
//                         {isNewWallet(wallet.createdAt) && (
//                           <span className="w-2 h-2 bg-blue-500 rounded-full flex-shrink-0"></span>
//                         )}
//                       </div>
//                     </td>
//                     <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                       <div className="flex items-center gap-2">
//                         <span>{formatDate(wallet.createdAt)}</span>
//                         {isNewWallet(wallet.createdAt) && (
//                           <span className="w-2 h-2 bg-blue-500 rounded-full flex-shrink-0"></span>
//                         )}
//                       </div>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         )}

//         {/* Pagination */}
//         {!loading && !error && wallets.length > 0 && (
//           <div className="px-6 py-4 bg-gray-50 border-t border-gray-200 flex items-center justify-between">
//             <div className="flex-1 flex justify-between sm:hidden">
//               <button
//                 onClick={() => handlePageChange(pagination.page - 1)}
//                 disabled={pagination.page === 1}
//                 className={`relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md 
//                   ${
//                     pagination.page === 1
//                       ? "bg-gray-100 text-gray-400 cursor-not-allowed"
//                       : "bg-white text-gray-700 hover:bg-gray-50"
//                   }`}
//               >
//                 Previous
//               </button>
//               <button
//                 onClick={() => handlePageChange(pagination.page + 1)}
//                 disabled={pagination.page === pagination.pages}
//                 className={`ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md 
//                   ${
//                     pagination.page === pagination.pages
//                       ? "bg-gray-100 text-gray-400 cursor-not-allowed"
//                       : "bg-white text-gray-700 hover:bg-gray-50"
//                   }`}
//               >
//                 Next
//               </button>
//             </div>
//             <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
//               <div>
//                 <p className="text-sm text-gray-700">
//                   Showing{" "}
//                   <span className="font-medium">
//                     {wallets.length > 0
//                       ? (pagination.page - 1) * pagination.limit + 1
//                       : 0}
//                   </span>{" "}
//                   to{" "}
//                   <span className="font-medium">
//                     {Math.min(
//                       pagination.page * pagination.limit,
//                       pagination.total
//                     )}
//                   </span>{" "}
//                   of <span className="font-medium">{pagination.total}</span>{" "}
//                   results
//                 </p>
//               </div>
//               <div>
//                 <div className="flex items-center">
//                   <select
//                     value={pagination.limit}
//                     onChange={(e) => {
//                       setPagination((prev) => ({
//                         ...prev,
//                         limit: parseInt(e.target.value),
//                         page: 1,
//                       }));
//                     }}
//                     className="mr-4 border border-gray-300 rounded-md text-gray-600 text-sm py-1 px-2"
//                   >
//                     <option value="10">10 per page</option>
//                     <option value="25">25 per page</option>
//                     <option value="50">50 per page</option>
//                     <option value="100">100 per page</option>
//                   </select>

//                   <nav
//                     className="relative z-0 inline-flex shadow-sm -space-x-px"
//                     aria-label="Pagination"
//                   >
//                     <button
//                       onClick={() => handlePageChange(1)}
//                       disabled={pagination.page === 1}
//                       className={`relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 text-sm font-medium 
//                         ${
//                           pagination.page === 1
//                             ? "bg-gray-100 text-gray-400 cursor-not-allowed"
//                             : "bg-white text-gray-500 hover:bg-gray-50"
//                         }`}
//                     >
//                       <span className="sr-only">First Page</span>
//                       &laquo;
//                     </button>

//                     <button
//                       onClick={() => handlePageChange(pagination.page - 1)}
//                       disabled={pagination.page === 1}
//                       className={`relative inline-flex items-center px-2 py-2 border border-gray-300 text-sm font-medium 
//                         ${
//                           pagination.page === 1
//                             ? "bg-gray-100 text-gray-400 cursor-not-allowed"
//                             : "bg-white text-gray-500 hover:bg-gray-50"
//                         }`}
//                     >
//                       <span className="sr-only">Previous</span>
//                       &lsaquo;
//                     </button>

//                     {Array.from(
//                       { length: Math.min(5, pagination.pages) },
//                       (_, i) => {
//                         let pageNumber;

//                         if (pagination.pages <= 5) {
//                           pageNumber = i + 1;
//                         } else if (pagination.page <= 3) {
//                           pageNumber = i + 1;
//                         } else if (pagination.page >= pagination.pages - 2) {
//                           pageNumber = pagination.pages - 4 + i;
//                         } else {
//                           pageNumber = pagination.page - 2 + i;
//                         }

//                         return (
//                           <button
//                             key={pageNumber}
//                             onClick={() => handlePageChange(pageNumber)}
//                             className={`relative inline-flex items-center px-4 py-2 border text-sm font-medium 
//                             ${
//                               pagination.page === pageNumber
//                                 ? "z-10 bg-blue-50 border-blue-500 text-blue-600"
//                                 : "bg-white border-gray-300 text-gray-500 hover:bg-gray-50"
//                             }`}
//                           >
//                             {pageNumber}
//                           </button>
//                         );
//                       }
//                     )}

//                     <button
//                       onClick={() => handlePageChange(pagination.page + 1)}
//                       disabled={pagination.page === pagination.pages}
//                       className={`relative inline-flex items-center px-2 py-2 border border-gray-300 text-sm font-medium 
//                         ${
//                           pagination.page === pagination.pages
//                             ? "bg-gray-100 text-gray-400 cursor-not-allowed"
//                             : "bg-white text-gray-500 hover:bg-gray-50"
//                         }`}
//                     >
//                       <span className="sr-only">Next</span>
//                       &rsaquo;
//                     </button>

//                     <button
//                       onClick={() => handlePageChange(pagination.pages)}
//                       disabled={pagination.page === pagination.pages}
//                       className={`relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 text-sm font-medium 
//                         ${
//                           pagination.page === pagination.pages
//                             ? "bg-gray-100 text-gray-400 cursor-not-allowed"
//                             : "bg-white text-gray-500 hover:bg-gray-50"
//                         }`}
//                     >
//                       <span className="sr-only">Last Page</span>
//                       &raquo;
//                     </button>
//                   </nav>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default WalletManagement;

import React, { useState, useEffect } from "react";
import { Loader, CheckCircle } from "lucide-react";
import { adminUserService } from "../../../services/api/admin.user.service";
import { notificationService } from "../../../services/api/notification.service";

const getAuthHeader = () => ({
  Authorization: `Bearer ${
    localStorage.getItem("authToken") || "your-token-here"
  }`,
});

const WalletManagement = () => {
  // State management
  const [wallets, setWallets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [markingAsRead, setMarkingAsRead] = useState(false);
  // Track last mark as read timestamp
  const [lastMarkAsReadTime, setLastMarkAsReadTime] = useState(null);
  const [pagination, setPagination] = useState({
    total: 0,
    page: 1,
    limit: 10,
    pages: 0,
  });

  // Filter states
  const [filters, setFilters] = useState({
    status: "",
    currency: "",
    minBalance: "",
    maxBalance: "",
    userId: "",
    search: "",
    sortBy: "createdAt",
    sortOrder: "desc",
  });

  // Load last mark as read timestamp from localStorage on component mount
  useEffect(() => {
    const savedTimestamp = localStorage.getItem('walletLastMarkAsReadTime');
    if (savedTimestamp) {
      setLastMarkAsReadTime(new Date(savedTimestamp));
    }
  }, []);

  // Helper function to check if wallet is new (created within last 24 hours)
  const isNewWallet = (createdAt) => {
    if (!createdAt) return false;
    const walletDate = new Date(createdAt);
    const now = new Date();
    const timeDifference = now - walletDate;
    const hoursDifference = timeDifference / (1000 * 60 * 60);
    return hoursDifference <= 24;
  };

  // Helper function to check if wallet should show blue dot
  const shouldShowBlueDot = (wallet) => {
    if (!isNewWallet(wallet.createdAt)) {
      return false;
    }

    // If we have a last mark as read time, check if wallet was created after that
    if (lastMarkAsReadTime) {
      const walletCreatedTime = new Date(wallet.createdAt);
      // Only show blue dot if wallet was created AFTER the last mark as read time
      return walletCreatedTime > lastMarkAsReadTime;
    }

    // If no mark as read time exists, show blue dot for all new wallets
    return true;
  };

  // Check if there are any new unread wallets
  const hasNewWallets = wallets.some(wallet => shouldShowBlueDot(wallet));

  // Fetch wallets with current filters and pagination
  const fetchWallets = async () => {
    try {
      setLoading(true);

      // Build query parameters
      const params = {
        page: pagination.page,
        limit: pagination.limit,
      };

      Object.keys(filters).forEach((key) => {
        if (
          filters[key] !== "" &&
          filters[key] !== null &&
          filters[key] !== undefined
        ) {
          params[key] = filters[key];
        }
      });

      // Call API from service
      const response = await adminUserService.getWallets(params);

      if (response.success) {
        setWallets(response.data.wallets);
        setPagination(response.data.pagination);
      } else {
        setError("Failed to fetch wallets");
      }
    } catch (err) {
      setError(err.message || "Error fetching wallet data");
    } finally {
      setLoading(false);
    }
  };

  // Handle marking wallet notifications as read
  const handleMarkAsRead = async () => {
    try {
      setMarkingAsRead(true);
      const response = await notificationService.markCategoryAsRead('Wallet');
      
      if (response.success) {
        // Set the current timestamp as the last mark as read time
        const currentTime = new Date();
        setLastMarkAsReadTime(currentTime);
        
        // Save to localStorage
        localStorage.setItem('walletLastMarkAsReadTime', currentTime.toISOString());
        
      
      } else {
        setError('Failed to mark notifications as read');
        console.error('Error marking notifications as read:', response.message);
      }
    } catch (error) {
      console.error('Error marking notifications as read:', error);
      setError('Failed to mark notifications as read');
    } finally {
      setMarkingAsRead(false);
    }
  };

  // Initial load and when filters/pagination change
  useEffect(() => {
    fetchWallets();
  }, [pagination.page, pagination.limit, filters.sortBy, filters.sortOrder]);

  // Handle filter changes
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Apply filters
  const applyFilters = (e) => {
    e.preventDefault();
    setPagination((prev) => ({
      ...prev,
      page: 1,
    }));
    fetchWallets();
  };

  // Reset filters
  const resetFilters = () => {
    setFilters({
      status: "",
      currency: "",
      minBalance: "",
      maxBalance: "",
      userId: "",
      search: "",
      sortBy: "createdAt",
      sortOrder: "desc",
    });

    setPagination((prev) => ({
      ...prev,
      page: 1,
    }));
  };

  // Handle sort change
  const handleSort = (field) => {
    setFilters((prev) => ({
      ...prev,
      sortBy: field,
      sortOrder:
        prev.sortBy === field && prev.sortOrder === "desc" ? "asc" : "desc",
    }));
  };

  // Handle page change
  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= pagination.pages) {
      setPagination((prev) => ({
        ...prev,
        page: newPage,
      }));
    }
  };

  // Format date to readable format
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleString();
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="flex flex-col sm:flex-row justify-between items-center mb-6 gap-4 sm:gap-0">
        <h1 className="text-2xl font-bold">Wallet Management</h1>
        
        {/* Mark as Read Button - Only show if there are new wallets */}
        {hasNewWallets && (
          <button
            onClick={handleMarkAsRead}
            disabled={markingAsRead}
            className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 disabled:bg-blue-400 text-white font-medium py-2 px-4 rounded-md transition-colors w-full sm:w-auto justify-center"
          >
            {markingAsRead ? (
              <Loader className="animate-spin" size={16} />
            ) : (
              <CheckCircle size={16} />
            )}
            {markingAsRead ? 'Marking as Read...' : 'Mark New Wallets as Read'}
          </button>
        )}
      </div>


      {/* Debug info - Remove in production */}
      {process.env.NODE_ENV === 'development' && lastMarkAsReadTime && (
        <div className="mb-4 bg-gray-100 border border-gray-300 rounded-md p-2">
          <small className="text-gray-600">
            Last marked as read: {formatDate(lastMarkAsReadTime.toISOString())}
          </small>
        </div>
      )}

      {/* Results Table */}
      <div className="overflow-hidden">
        {loading ? (
          <div className="flex justify-center items-center h-screen">
            <Loader className="animate-spin text-indigo-500" size={36} />
          </div>
        ) : error ? (
          <div className="text-center py-8 text-red-500">
            <p>{error}</p>
            <button
              onClick={fetchWallets}
              className="mt-4 bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-md transition-colors"
            >
              Try Again
            </button>
          </div>
        ) : wallets.length === 0 ? (
          <div className="text-center py-8 text-gray-500">
            <p>No wallets found matching your criteria.</p>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    User Details
                  </th>
                  <th
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer"
                    onClick={() => handleSort("currency")}
                  >
                    Currency
                    {filters.sortBy === "currency" && (
                      <span className="ml-1">
                        {filters.sortOrder === "asc" ? "↑" : "↓"}
                      </span>
                    )}
                  </th>
                  <th
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer"
                    onClick={() => handleSort("balance")}
                  >
                    Balance
                    {filters.sortBy === "balance" && (
                      <span className="ml-1">
                        {filters.sortOrder === "asc" ? "↑" : "↓"}
                      </span>
                    )}
                  </th>
                  <th
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer"
                    onClick={() => handleSort("status")}
                  >
                    Status
                    {filters.sortBy === "status" && (
                      <span className="ml-1">
                        {filters.sortOrder === "asc" ? "↑" : "↓"}
                      </span>
                    )}
                  </th>
                  <th
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer"
                    onClick={() => handleSort("createdAt")}
                  >
                    Created At
                    {filters.sortBy === "createdAt" && (
                      <span className="ml-1">
                        {filters.sortOrder === "asc" ? "↑" : "↓"}
                      </span>
                    )}
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {wallets.map((wallet) => (
                  <tr key={wallet._id} className="hover:bg-gray-50">
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center gap-3">
                        <div className="flex flex-col">
                          <div className="text-sm font-medium text-gray-900 flex items-center gap-2">
                            {wallet.userDetails.fullName}
                            {shouldShowBlueDot(wallet) && (
                              <span className="w-2 h-2 bg-blue-500 rounded-full flex-shrink-0"></span>
                            )}
                          </div>
                          <div className="text-sm text-gray-500">
                            {wallet.userDetails.email}
                          </div>
                          <div className="text-xs text-gray-500">
                            {wallet.userDetails.mobileNo}
                          </div>
                          <div className="text-xs text-gray-400">
                            ID: {wallet.user.toString()}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center gap-2">
                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                          {wallet.currency}
                        </span>
                        {shouldShowBlueDot(wallet) && (
                          <span className="w-2 h-2 bg-blue-500 rounded-full flex-shrink-0"></span>
                        )}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center gap-2">
                        <div className="text-sm font-medium text-gray-900">
                          {parseFloat(wallet.balance).toFixed(4)}
                        </div>
                        {shouldShowBlueDot(wallet) && (
                          <span className="w-2 h-2 bg-blue-500 rounded-full flex-shrink-0"></span>
                        )}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center gap-2">
                        <span
                          className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium
                          ${
                            wallet.status === "ACTIVE"
                              ? "bg-green-100 text-green-800"
                              : wallet.status === "INACTIVE"
                              ? "bg-gray-100 text-gray-800"
                              : wallet.status === "FROZEN"
                              ? "bg-red-100 text-red-800"
                              : "bg-yellow-100 text-yellow-800"
                          }
                        `}
                        >
                          {wallet.status}
                        </span>
                        {shouldShowBlueDot(wallet) && (
                          <span className="w-2 h-2 bg-blue-500 rounded-full flex-shrink-0"></span>
                        )}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                      <div className="flex items-center gap-2">
                        <span>{formatDate(wallet.createdAt)}</span>
                        {shouldShowBlueDot(wallet) && (
                          <span className="w-2 h-2 bg-blue-500 rounded-full flex-shrink-0"></span>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
  
  


        {/* Pagination */}
        {!loading && !error && wallets.length > 0 && (
          <div className="px-6 py-4 bg-gray-50 border-t border-gray-200 flex flex-col sm:flex-row items-center justify-between gap-4 sm:gap-0"> {/* Adjusted flex direction and gap */}
            <div className="flex-1 flex justify-between sm:hidden w-full"> {/* Ensures full width on small screens */}
              <button
                onClick={() => handlePageChange(pagination.page - 1)}
                disabled={pagination.page === 1}
                className={`relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md w-1/2 justify-center
                  ${
                    pagination.page === 1
                      ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                      : "bg-white text-gray-700 hover:bg-gray-50"
                  }`}
              >
                Previous
              </button>
              <button
                onClick={() => handlePageChange(pagination.page + 1)}
                disabled={pagination.page === pagination.pages}
                className={`ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md w-1/2 justify-center
                  ${
                    pagination.page === pagination.pages
                      ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                      : "bg-white text-gray-700 hover:bg-gray-50"
                  }`}
              >
                Next
              </button>
            </div>
            <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between w-full"> {/* Ensures full width on small screens when hidden */}
              <div>
                <p className="text-sm text-gray-700 text-center sm:text-left"> {/* Centered text on small, left on larger */}
                  Showing{" "}
                  <span className="font-medium">
                    {wallets.length > 0
                      ? (pagination.page - 1) * pagination.limit + 1
                      : 0}
                  </span>{" "}
                  to{" "}
                  <span className="font-medium">
                    {Math.min(
                      pagination.page * pagination.limit,
                      pagination.total
                    )}
                  </span>{" "}
                  of <span className="font-medium">{pagination.total}</span>{" "}
                  results
                </p>
              </div>
              <div>
                <div className="flex items-center justify-center sm:justify-start"> {/* Centered buttons on small, left on larger */}
                  <select
                    value={pagination.limit}
                    onChange={(e) => {
                      setPagination((prev) => ({
                        ...prev,
                        limit: parseInt(e.target.value),
                        page: 1,
                      }));
                    }}
                    className="mr-4 border border-gray-300 rounded-md text-gray-600 text-sm py-1 px-2"
                  >
                    <option value="10">10 per page</option>
                    <option value="25">25 per page</option>
                    <option value="50">50 per page</option>
                    <option value="100">100 per page</option>
                  </select>

                  <nav
                    className="relative z-0 inline-flex shadow-sm -space-x-px"
                    aria-label="Pagination"
                  >
                    <button
                      onClick={() => handlePageChange(1)}
                      disabled={pagination.page === 1}
                      className={`relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 text-sm font-medium 
                        ${
                          pagination.page === 1
                            ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                            : "bg-white text-gray-500 hover:bg-gray-50"
                        }`}
                    >
                      <span className="sr-only">First Page</span>
                      &laquo;
                    </button>

                    <button
                      onClick={() => handlePageChange(pagination.page - 1)}
                      disabled={pagination.page === 1}
                      className={`relative inline-flex items-center px-2 py-2 border border-gray-300 text-sm font-medium 
                        ${
                          pagination.page === 1
                            ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                            : "bg-white text-gray-500 hover:bg-gray-50"
                        }`}
                    >
                      <span className="sr-only">Previous</span>
                      &lsaquo;
                    </button>

                    {Array.from(
                      { length: Math.min(5, pagination.pages) },
                      (_, i) => {
                        let pageNumber;

                        if (pagination.pages <= 5) {
                          pageNumber = i + 1;
                        } else if (pagination.page <= 3) {
                          pageNumber = i + 1;
                        } else if (pagination.page >= pagination.pages - 2) {
                          pageNumber = pagination.pages - 4 + i;
                        } else {
                          pageNumber = pagination.page - 2 + i;
                        }

                        return (
                          <button
                            key={pageNumber}
                            onClick={() => handlePageChange(pageNumber)}
                            className={`relative inline-flex items-center px-4 py-2 border text-sm font-medium 
                              ${
                                pagination.page === pageNumber
                                  ? "z-10 bg-blue-50 border-blue-500 text-blue-600"
                                  : "bg-white border-gray-300 text-gray-500 hover:bg-gray-50"
                              }`}
                          >
                            {pageNumber}
                          </button>
                        );
                      }
                    )}

                    <button
                      onClick={() => handlePageChange(pagination.page + 1)}
                      disabled={pagination.page === pagination.pages}
                      className={`relative inline-flex items-center px-2 py-2 border border-gray-300 text-sm font-medium 
                        ${
                          pagination.page === pagination.pages
                            ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                            : "bg-white text-gray-500 hover:bg-gray-50"
                        }`}
                    >
                      <span className="sr-only">Next</span>
                      &rsaquo;
                    </button>

                    <button
                      onClick={() => handlePageChange(pagination.pages)}
                      disabled={pagination.page === pagination.pages}
                      className={`relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 text-sm font-medium 
                        ${
                          pagination.page === pagination.pages
                            ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                            : "bg-white text-gray-500 hover:bg-gray-50"
                        }`}
                    >
                      <span className="sr-only">Last Page</span>
                      &raquo;
                    </button>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default WalletManagement;